
function pushEventVideo(action, event) {
    var title = $('.js-cloudinary-video[data-videoid="' + event.Player.options.videojsOptions.id + '"]').data('analyticstitle');
    $(document).trigger('analytics:video', { eventAction: action, eventLabel: title });
}

function restartInizializedVideo(videoId) {
    $('.js-cloudinary-video').each(function() {
        var videoRef = $(this);
        var videoConf = videoRef.data('videoconf');
        var videoId = videoRef.data('videoid');
        var confObj = JSON.parse(JSON.parse(videoConf));
        if (confObj.playerConfig.autoplay) {
            var inizializedVideo = videojs.players[videoId];
            if (inizializedVideo) {
                inizializedVideo.play();
            }
        };
    });
}

function initializeCloudinaryPlayer(cld, videoId, playerConf) {
    if (!$('#' + videoId).is('video')) {
        return; // prevent multi vidoe initialization
    }
    var p = cld.videoPlayer(videoId, playerConf.playerConfig);
    // avoid overriding of video transformation defined on page designer video config
    // var currentTransformations = playerConf.sourceConfig.transformation;

    // var cropActive = false;
    // searching for current page designer video transformation
    // for (var i = 0; i < currentTransformations.length; i++) {
    //     var transf = currentTransformations[i];
    //     for (const [key, value] of Object.entries(transf)) {
    //         // if (value.indexOf('c_') > -1) {
    //         //     cropActive = true;
    //         // }
    //     }
    // }
    // var chain = p.transformation();
    // if (!cropActive) {
        // var videoNativeWidth = playerConf.sourceConfig.video.asset.width;
        // var width = $('[data-videoid="' + videoId + '"]').width();
        // if (width) {
        //     var ceil = Math.ceil(width);
        //     if (ceil < videoNativeWidth) {
        //         chain.crop('scale').width(ceil);
        //     }
        // }
        // TODO: si generano troppe trasformazioni, gestire i breakpoint? 4k, fullhd, tablet ( mobile può restare come è )
        // chain.crop('scale');
    // }

    p.source(playerConf.publicId, playerConf.sourceConfig);
    p.on('error', function(e) {
        const error = e.Player.videojs.error();
        var elemernt = $('[data-videoid="' + videoId + '"]');
        $(elemernt).hide();
        if (error && error.code === 10) {
            p.videojs.error(null);
            p.videojs.error({
                code: null, message: 'Generating the video, please wait.'
            });
        }
    });
    p.on('pause', function(e) {
        if (e.Player.options.videojsOptions.controls) {
            pushEventVideo('pause', e);
        }
    });
    p.on('play', function(e) {
        if (e.Player.options.videojsOptions.controls) {
            pushEventVideo('play', e);
        }
    });
    p.on('percentsplayed', function(e) {
        if (e.Player.options.videojsOptions.controls) {
            var event = 'progress - ' + e.eventData.percent + '%';
            pushEventVideo(event, e);
        }
    });
}

function initCloudinaryVideos(e) {
    var cld;
    $('.js-cloudinary-video').each(function() {
        var videoRef = $(this);
        var videoCong = videoRef.data('videoconf');
        var videoId = videoRef.data('videoid');
        var confObj = JSON.parse(JSON.parse(videoCong));
        confObj.playerConfig.colors = {
            accent: '#7c7c7c'
        };
        confObj.playerConfig.fluid = true;
        confObj.playerConfig.fontFace = 'inherit';
        confObj.playerConfig.playedEventPercents = [25, 50, 75, 100];
        // confObj.playerConfig.analytics = true; NON compatibile con datalayer
        if (!cld) {
            let conf = {
                cloud_name: confObj.cloudName
            };
            if (confObj.cname) {
                conf.secure_distribution = confObj.cname;
                conf.private_cdn = true;
            }
            cld = cloudinary.Cloudinary.new(conf);
            let config = cld.config();
            if (config.secure === false) {
                delete cld.config({ cname: window.cname }).secure_distribution;
            }
        }
        if ((!videoRef.parent().hasClass('cc-content-video-mobile') && !videoRef.parent().hasClass('cc-content-video-desktop')) || // only desktop video available
            (videoRef.parent().hasClass('cc-content-video-mobile') && $('body').hasClass('cc-mobile')) || // video mobile and body mobile
            (videoRef.parent().hasClass('cc-content-video-desktop') && !$('body').hasClass('cc-mobile'))) { // video desktop and body desktop
            initializeCloudinaryPlayer(cld, videoId, confObj);
        }
    });
}

$(document).ready(function() {
    initCloudinaryVideos();
});

module.exports = {
    initCloudinaryVideos: initCloudinaryVideos,
    restartInizializedVideo: restartInizializedVideo
};
